import { render, staticRenderFns } from "./LinkedUsers.vue?vue&type=template&id=0c225e68&scoped=true&"
import script from "./LinkedUsers.vue?vue&type=script&lang=js&"
export * from "./LinkedUsers.vue?vue&type=script&lang=js&"
import style0 from "./LinkedUsers.vue?vue&type=style&index=0&id=0c225e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c225e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VRow,VSimpleTable})
